<template>
  <div>
    <el-card :style="autoHeight" style="display: flex; width: 100% !important;" class="cab">
      <el-scrollbar style="height: 100%;" ref="scrollbar">

        <div class="info-header">
          <span style="font-weight: bolder;float: left;font-size: 15px">人员基本信息</span>
        </div>
        <div class="info-body" style="margin-top: 20px;padding: 0 10px;">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="姓名：">
                  <basic-info-detail :code-value="form.name"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号：" prop="userId">
                  <basic-info-detail :code-value="form.userId"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别：">
                  <basic-info-detail :flag="2" :code-value="form.gender" :code-array="array.genderArr"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="籍贯:">
                  <span class="form_span" v-if="this.$route.query.flag == 'view'">{{ pCodeAndCName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="证件类型">
                  <basic-info-detail :flag="2" :code-value="form.idTypeCode" :code-array="array.idTypeCodeArr"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件号码：">
                  <basic-info-detail :code-value="form.idNumber"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="出生年月日：">
                  <span class="form_span">{{ form.birthDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="民族：">
                  <basic-info-detail :flag="2" :code-value="form.ethnicityCode" :code-array="array.ethnicityCodeArr" ></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="政治面貌：">
                  <basic-info-detail :flag="2" :code-value="form.politicalAppearanceCode" :code-array="array.politicalAppearanceCodeArr" ></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="邮箱：">
                  <basic-info-detail :code-value="form.email"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系电话（长号）：">
                  <basic-info-detail :code-value="form.telNumLong"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系电话（短号）：">
                  <basic-info-detail :code-value="form.telNumShort"></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="info-header">
          <span style="font-weight: bolder;float: left;font-size: 15px">所属机构信息</span>
        </div>
        <div class="info-body" style="margin-top: 20px; padding: 0 10px;">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="所属机构：">
                  <span class="form_span">{{ deptName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="科室：">
                  <basic-info-detail :code-value="form.section"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="当前科室职务：">
                  <basic-info-detail :code-value="form.currentSectionPosition"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="工号">
                  <basic-info-detail :code-value="form.workNumber"></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="来院时间">
                  <span class="form_span">{{ form.hospitalDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="工作时间">
                  <span class="form_span">{{ form.workDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="现职称等级">
                  <basic-info-detail :flag="2" :code-value="form.currentTitleLevelCode" :code-array="array.currentTitleLevelCodeArr"></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="info-header">
          <span style="font-weight: bolder;float: left;font-size: 15px">教育背景</span>
        </div>
        <div class="info-body" style="margin-top: 20px; padding: 0 10px;">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="学历：">
                  <basic-info-detail :code-value="form.educationCode" :code-array="array.educationCodeArr" ></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学位：">
                  <basic-info-detail :code-value="form.degreeCode" :code-array="array.degreeCodeArr" ></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="研究方向：">
                  <basic-info-detail :code-value="form.researchDirection"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否学科带头人：">
                  <basic-info-detail :flag="2"  :code-value="form.isDisciplineLeader" :code-array="array.trueOrFalse" ></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否学术带头人：">
                  <basic-info-detail :flag="2"  :code-value="form.isAcademicLeader" :code-array="array.trueOrFalse"></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="大学学校：">
                  <basic-info-detail :code-value="form.universitySchool"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="大学专业：">
                  <basic-info-detail :code-value="form.universityMajor"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="大学入读时间：">
                  <span class="form_span">{{ form.universityAdmDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="大学毕业时间：">
                  <span class="form_span">{{ form.universityGradDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="本科学校：">
                  <basic-info-detail :code-value="form.undergradSchool"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本科专业：">
                  <basic-info-detail :code-value="form.undergradMajor"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本科入读时间：">
                  <span class="form_span">{{ form.undergradAdmDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本科毕业时间：">
                  <span class="form_span">{{ form.undergradGradDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="硕士学校：">
                  <basic-info-detail :code-value="form.masterSchool"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="硕士专业：">
                  <basic-info-detail :code-value="form.masterMajor"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="硕士入读时间：">
                  <span class="form_span">{{ form.masterAdmDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="硕士毕业时间：">
                  <span class="form_span">{{ form.masterGradDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="博士学校：">
                  <basic-info-detail :code-value="form.phdSchool"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士专业：">
                  <basic-info-detail :code-value="form.phdMajor"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士入读时间：">
                  <span class="form_span">{{ form.phdAdmDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士毕业时间：">
                  <span class="form_span">{{ form.phdGradDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="博士后学校：">
                  <basic-info-detail :code-value="form.postDoctoralSchool"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士后专业：">
                  <basic-info-detail :code-value="form.postDoctoralMajor"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士后入读时间：">
                  <span class="form_span">{{ form.postDoctoralAdmDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士后毕业时间：">
                  <span class="form_span">{{ form.postDoctoralGradDate | dateFormat }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="硕士导师姓名：">
                  <basic-info-detail :code-value="form.masterTutorName"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士导师姓名：">
                  <basic-info-detail :code-value="form.phdTutorName"></basic-info-detail>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="博士后导师姓名">
                  <basic-info-detail :code-value="form.postDoctoralTutorName"></basic-info-detail>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="info-header">
          <span style="font-weight: bolder;float: left;font-size: 16px">所获荣誉</span>
        </div>
        <div class="info-body" style="margin-top: 20px; padding: 0 10px; width: 100%">
          <el-collapse>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;执业资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否有执业资格：">
                        <basic-info-detail :flag="2" :code-value="form.practiceQual" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="执业证发证时间：">
                        <span class="form_span">{{ form.practiceLicTime | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="执业证编码：">
                        <basic-info-detail :flag="2" :code-value="form.practiceLicCode" :code-array="array.practiceLicCodeArr"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="执业证执业类别：">
                        <basic-info-detail :flag="2" :code-value="form.practiceLicTypeCode" :code-array="array.practiceLicTypeCodeArr"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="执业证执业范围：">
                        <basic-info-detail :flag="2" :code-value="form.practiceLicScopeCode" :code-array="array.practiceLicScopeCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 270px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.practiceQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.practiceQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;医师资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否拥有医师资格：">
                        <basic-info-detail :flag="2" :code-value="form.medicalQual" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="医师资格证发证时间：">
                        <span class="form_span">{{ form.medicalLicTime | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="医师证编码：">
                        <basic-info-detail :flag="2" :code-value="form.medicalLicCode" :code-array="array.medicalLicCodeArr"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="医师证专业：">
                        <basic-info-detail :flag="2" :code-value="form.medicalLicSpecialtyCode" :code-array="array.medicalLicSpecialtyCodeArr"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="医师证类别：">
                        <basic-info-detail :flag="2" :code-value="form.medicalLicTypeCode" :code-array="array.medicalLicTypeCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 270px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.medicalLicAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.medicalLicAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;初级专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="初级专业技术资格证时间：">
                        <span class="form_span">{{ form.juniorProQualDate | dateFormat}}</span>
                      </el-form-item>
                      <el-form-item label="初级专业技术资格证专业名称：">
                        <basic-info-detail :code-value="form.juniorProQualName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="初级专业技术资格证资格级别：">
                        <basic-info-detail :flag="2" :code-value="form.juniorProQualLevelCode" :code-array="array.juniorProQualLevelCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 150px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.juniorProQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.juniorProQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;中级专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="中级专业技术资格证时间：">
                        <span class="form_span">{{ form.imdProQualDate | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="中级专业技术资格证专业名称：">
                        <basic-info-detail :code-value="form.imdProQualName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="中级专业技术资格证资格级别：">
                        <basic-info-detail :flag="2" :code-value="form.imdProQualLevelCode" :code-array="array.imdProQualLevelCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 150px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.imdProQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.imdProQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;副高级专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="副高级专业技术资格证时间：">
                        <span class="form_span">{{ form.ascSnrProQualDate | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="副高级专业技术资格评审委员会：">
                        <basic-info-detail :code-value="form.ascSnrProQualJury"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="副高级专业技术资格证专业名称：">
                        <basic-info-detail :code-value="form.ascSnrProQualName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="副高级专业技术任职资格名称：">
                        <basic-info-detail :code-value="form.ascSnrProQualApptName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="副高级专业技术资格证编号：">
                        <basic-info-detail :flag="2" :code-value="form.ascSnrProQualLicCode" :code-array="array.ascSnrProQualLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 270px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.ascSnrProQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.ascSnrProQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;正高级专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="正高级专业技术资格证时间：">
                        <span class="form_span">{{ form.posSnrProQualDate | dateFormat}}</span>
                      </el-form-item>
                      <el-form-item label="正高级专业技术资格评审委员会：">
                        <basic-info-detail :code-value="form.posSnrProQualJury"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="正高级专业技术资格证专业名称：">
                        <basic-info-detail :code-value="form.posSnrProQualName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="正高级专业技术任职资格名称：">
                        <basic-info-detail :code-value="form.posSnrProQualApptName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="正高级专业技术资格证编号：">
                        <basic-info-detail :flag="2" :code-value="form.posSnrProQualLicCode" :code-array="array.posSnrProQualLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 270px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.posSnrProQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.posSnrProQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;教师资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否有教师资格：">
                        <basic-info-detail :flag="2" :code-value="form.teacherQual" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="教师证书获得时间：">
                        <span class="form_span">{{ form.teacherLicDate | dateFormat}}</span>
                      </el-form-item>
                      <el-form-item label="教师资格种类：">
                        <basic-info-detail :flag="2" :code-value="form.teacherQualTypeCode" :code-array="array.teacherQualTypeCodeArr"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="教师证书编号：">
                        <basic-info-detail :flag="2" :code-value="form.teacherLicCode" :code-array="array.teacherLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 210px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.teacherQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.teacherQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;讲师资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否有讲师资格">
                        <basic-info-detail :flag="2" :code-value="form.lecturerQual" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="讲师证书获得时间">
                        <span class="form_span">{{ form.lecturerLicDate | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="讲师证书名称">
                        <basic-info-detail :code-value="form.lecturerLicName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="讲师证书编号">
                        <basic-info-detail :flag="2" :code-value="form.lecturerLicCode" :code-array="array.lecturerLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 210px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.lecturerQualAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.lecturerQualAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;副教授专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否有副教授资格">
                        <basic-info-detail :flag="2" :code-value="form.ascProfessor" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="副教授专业技术资格证发证时间">
                        <span class="form_span">{{ form.ascProfessorLicDate | dateFormat}}</span>
                      </el-form-item>
                      <el-form-item label="副教授专业技术资格专业名称">
                        <basic-info-detail :code-value="form.ascProfessorLicName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="副教授专业技术资格证编号：">
                        <basic-info-detail :flag="2" :code-value="form.ascProfessorLicCode" :code-array="array.ascProfessorLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 210px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.ascProfessorAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.ascProfessorAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;教授专业技术资格证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否有教授资格：">
                        <basic-info-detail :flag="2" :code-value="form.professor" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="教授专业技术资格证发证时间：">
                        <span class="form_span">{{ form.professorLicDate | dateFormat }}</span>
                      </el-form-item>
                      <el-form-item label="教授专业技术资格专业名称：">
                        <basic-info-detail :code-value="form.professorLicName"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="教授资格评审委员会：">
                        <basic-info-detail :code-value="form.professorQualJury"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="教授专业技术资格证编号">
                        <basic-info-detail :flag="2" :code-value="form.professorLicCode" :code-array="array.professorLicCodeArr"></basic-info-detail>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 270px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.professorAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.professorAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;硕士导师
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否硕士导师：">
                        <basic-info-detail :flag="2" :code-value="form.masterInstructor" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="硕士导师获得时间：">
                        <span class="form_span">{{ form.masterInstructorDate | dateFormat }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 120px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.masterInstructorAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.masterInstructorAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;博士导师
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否博士导师：">
                        <basic-info-detail :flag="2" :code-value="form.doctorInstructor" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="博士导师获得时间：">
                        <span class="form_span">{{ form.doctorInstructorDate | dateFormat }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 120px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.doctorInstructorAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.doctorInstructorAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <i class="icon-zhengshu"></i>&nbsp;Gcp证
              </template>
              <div style="margin-top: 10px">
                <el-form>
                  <el-row :gutter="40">
                    <el-col :span="8">
                      <el-form-item label="是否拥有GCP证">
                        <basic-info-detail :flag="2" :code-value="form.gcp" :code-array="array.trueOrFalse"></basic-info-detail>
                      </el-form-item>
                      <el-form-item label="GCP证获得时间">
                        <span class="form_span">{{ form.gcpDate | dateFormat }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <div class="panelRight" style="height: 100%;overflow-y: hidden;text-align: center">
                        <div style="text-align: center;padding-bottom:10px;font-size: 14px;font-weight: bold;">附件信息</div>
                        <el-scrollbar style="height: 120px" ref="scrollbar">
                          <div style="width: calc(100% - 20px)">
                            <el-table :data="fileDialog.gcpAttachs.tableDataList" border size="small">
                              <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
                              <el-table-column align="center" prop="attachmentName" label="文件别名" >
                                <template slot-scope="scope">
                                  <el-input class="text-input" v-model="scope.row.attachmentName" disabled></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column align="center" prop="" label="操作" width="100">
                                <template slot-scope="scope">
                                  <!--查看附件-->
                                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row, scope.$index, fileDialog.gcpAttachs.cd)"></el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-scrollbar>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="demo-image__preview">
          <el-image
            ref="previewImg"
            :preview-src-list="attachment.attachmentsLink">
          </el-image>
        </div>
      </el-scrollbar>
    </el-card>
  </div>
</template>

<script>
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import {mapState} from "vuex";
  import {getCascaderFullValue} from '@/utils/cascader';
  import {CARD_HEIGHT_TYPE,ATTA_FILE_SUF_LIST,ATTA_FILE_SHOW_TYPE,ATTA_FILE_DOWN_TYPE} from '@/constants/constants';
  import BasicInfoDetail from "./BasicInfoDetail";

  export default {
    name: "BasicUpdateInfo",
    components: {BasicInfoDetail},
    data() {
      return {
        elementDeptId:[],
        form: {
          name: '',
          userId: '',
          majorDepartId: '',
          ethnicityCode: '',
          gender: '',
          birthDate: '',
          idTypeCode: '',
          idNumber: '',
          originProvinceCode: '',
          originCityCode: '',
          politicalAppearanceCode: '',
          telNumLong: '',
          telNumShort: '',
          email: '',
          workNumber: '',
          section: '',
          currentSectionPosition: '',
          hospitalDate: '',
          workDate: '',
          educationCode: '',
          degreeCode: '',
          researchDirection: '',
          universitySchool: '',
          universityMajor: '',
          universityAdmDate: '',
          universityGradDate: '',
          undergradSchool: '',
          undergradMajor: '',
          undergradAdmDate: '',
          undergradGradDate: '',
          masterSchool: '',
          masterMajor: '',
          masterAdmDate: '',
          masterGradDate: '',
          masterTutorName: '',
          phdSchool: '',
          phdMajor: '',
          phdAdmDate: '',
          phdGradDate: '',
          phdTutorName: '',
          postDoctoralSchool: '',
          postDoctoralMajor: '',
          postDoctoralAdmDate: '',
          postDoctoralGradDate: '',
          postDoctoralTutorName: '',
          isDisciplineLeader: '',
          isAcademicLeader: '',
          practiceQual: '',
          practiceLicTime: '',
          practiceLicCode: '',
          practiceLicTypeCode: '',
          practiceLicScopeCode: '',
          medicalQual: '',
          medicalLicTime: '',
          medicalLicCode: '',
          medicalLicSpecialtyCode: '',
          medicalLicTypeCode: '',
          currentTitleLevelCode: '',
          juniorProQualDate: '',
          juniorProQualName: '',
          juniorProQualLevelCode: '',
          imdProQualDate: '',
          imdProQualName: '',
          imdProQualLevelCode: '',
          ascSnrProQualDate: '',
          ascSnrProQualJury: '',
          ascSnrProQualName: '',
          ascSnrProQualApptName: '',
          ascSnrProQualLicCode: '',
          posSnrProQualDate: '',
          posSnrProQualJury: '',
          posSnrProQualName: '',
          posSnrProQualApptName: '',
          posSnrProQualLicCode: '',
          teacherQual: '',
          teacherQualTypeCode: '',
          teacherLicCode: '',
          teacherLicDate: '',
          lecturerQual: '',
          lecturerLicDate: '',
          lecturerLicName: '',
          lecturerLicCode: '',
          ascProfessor: '',
          ascProfessorLicDate: '',
          ascProfessorLicName: '',
          ascProfessorLicCode: '',
          professor: '',
          professorLicDate: '',
          professorQualJury: '',
          professorLicName: '',
          professorLicCode: '',
          masterInstructor: '',
          masterInstructorDate: '',
          doctorInstructor: '',
          doctorInstructorDate: '',
          gcp: '',
          gcpDate: '',
          //附件列表
          practiceQualAttachs: [],
          medicalLicAttachs:[],
          juniorProQualAttachs:[],
          imdProQualAttachs:[],
          ascSnrProQualAttachs:[],
          posSnrProQualAttachs:[],
          teacherQualAttachs:[],
          lecturerQualAttachs:[],
          ascProfessorAttachs:[],
          professorAttachs:[],
          masterInstructorAttachs:[],
          doctorInstructorAttachs:[],
          gcpAttachs:[],
        },
        array: {
          idTypeCodeArr:[], //证件类型码表
          ethnicityCodeArr: [
            {
              cdDesc: "汉族",
              cd: '1'
            },
            {
              cdDesc: '壮族',
              cd: '2'
            }
          ],
          genderArr: [
            {
              cdDesc: "男",
              cd: '1'
            },
            {
              cdDesc: "女",
              cd: "0",
            }
          ],
          politicalAppearanceCodeArr: [
            {
              cdDesc: "共产党员",
              cd: '0',
            },
            {
              cdDesc: "共青团员",
              cd: "1"
            },
            {
              cdDesc: "群众",
              cd: "2"
            }
          ],
          educationCodeArr: [
            {
              cdDesc: "高中",
              cd: "1"
            },
            {
              cdDesc: "专科",
              cd: "2"
            },
            {
              cdDesc: "本科",
              cd: "3"
            }
          ],
          degreeCodeArr: [
            {
              cdDesc: "学士学位",
              cd: "1"
            },
            {
              cdDesc: "硕士学位",
              cd: "2"
            },
            {
              cdDesc: "博士学位",
              cd: "3"
            }
          ],
          trueOrFalse: [
            {
              cdDesc: "是",
              cd: "1"
            },
            {
              cdDesc: "否",
              cd: "0"
            }
          ],
          practiceLicCodeArr: [
            {
              cdDesc: "001",
              cd: "1"
            },
            {
              cdDesc: "002",
              cd: "2"
            },
            {
              cdDesc: "003",
              cd: "3"
            },
          ],
          practiceLicTypeCodeArr: [
            {
              cdDesc: "类别1",
              cd: "1"
            },
            {
              cdDesc: "类别2",
              cd: "2"
            },
            {
              cdDesc: "类别3",
              cd: "3"
            }
          ],
          practiceLicScopeCodeArr: [
            {
              cdDesc: '范围1',
              cd: '1'
            },
            {
              cdDesc: '范围2',
              cd: '2'
            },
            {
              cdDesc: '范围3',
              cd: '3'
            }
          ],
          medicalLicCodeArr: [
            {
              cdDesc: "001",
              cd: "1"
            },
            {
              cdDesc: "002",
              cd: "2"
            },
            {
              cdDesc: "003",
              cd: "3"
            }
          ],
          medicalLicSpecialtyCodeArr: [
            {
              cdDesc: "专业1",
              cd: "1"
            },
            {
              cdDesc: "专业2",
              cd: "2"
            },
            {
              cdDesc: "专业3",
              cd: "3"
            }
          ],
          medicalLicTypeCodeArr: [
            {
              cdDesc: '类别1',
              cd: '1'
            },
            {
              cdDesc: '类别2',
              cd: '2'
            },
            {
              cdDesc: '类别3',
              cd: '3'
            }
          ],
          currentTitleLevelCodeArr: [
            {
              cdDesc: "等级1",
              cd: "1"
            },
            {
              cdDesc: "等级2",
              cd: "2"
            },
            {
              cdDesc: "等级3",
              cd: "3"
            }
          ],
          juniorProQualLevelCodeArr: [
            {
              cdDesc: '级别一',
              cd: '1',
            },
            {
              cdDesc: '级别二',
              cd: '2',
            },
            {
              cdDesc: '级别三',
              cd: '3',
            }
          ],
          imdProQualLevelCodeArr: [
            {
              cdDesc: '级别一',
              cd: '1',
            },
            {
              cdDesc: '级别二',
              cd: '2',
            },
            {
              cdDesc: '级别三',
              cd: '3',
            }
          ],
          ascSnrProQualLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ],
          posSnrProQualLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ],
          teacherQualTypeCodeArr: [
            {
              cdDesc: "种类一",
              cd: "1"
            },
            {
              cdDesc: "种类二",
              cd: "2"
            },
            {
              cdDesc: "种类三",
              cd: "3"
            }
          ],
          teacherLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ],
          lecturerLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ],
          ascProfessorLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ],
          professorLicCodeArr: [
            {
              cdDesc: '001',
              cd: '1'
            },
            {
              cdDesc: '002',
              cd: '2'
            },
            {
              cdDesc: '003',
              cd: '3'
            }
          ]
        },
        attachment:{
          //附件上传框 是否可见
          opt:true,
          editedFlag: true,
          attachmentsLink:[],
          //图片的类型后缀
          imagesType:['jpg','jpeg','png','gif'],
        },
        fileFlag:{
          attaFileSuf:ATTA_FILE_SUF_LIST,
          attaFileType:ATTA_FILE_SHOW_TYPE,
          attaFileDownType:ATTA_FILE_DOWN_TYPE,
          drawerVisible: false,
          fileSaveBtnLoading: false,
          updateFlag:false,
          uploadLoading:false,
        },
        fileDialog:{
          practiceQualAttachs:{
            attachmentName:'',
            cd:'001-001',
            //真实的附件信息,没有id的,只是附件的二进制文件 的数组
            fileList: [],
            //附件的名字而已,别名 code id...  的数组
            tableDataList:[],
          },
          medicalLicAttachs:{
            attachmentName:'',
            cd:'001-036',
            fileList: [],
            tableDataList:[],
          },
          juniorProQualAttachs:{
            attachmentName:'',
            cd:'001-037',
            fileList: [],
            tableDataList:[],
          },
          imdProQualAttachs:{
            attachmentName:'',
            cd:'001-038',
            fileList: [],
            tableDataList:[],
          },
          ascSnrProQualAttachs:{
            attachmentName:'',
            cd:'001-029',
            fileList: [],
            tableDataList:[],
          },
          posSnrProQualAttachs:{
            attachmentName:'',
            cd:'001-030',
            fileList: [],
            tableDataList:[],
          },
          teacherQualAttachs:{
            attachmentName:'',
            cd:'001-031',
            fileList: [],
            tableDataList:[],
          },
          lecturerQualAttachs:{
            attachmentName:'',
            cd:'001-032',
            fileList: [],
            tableDataList:[],
          },
          ascProfessorAttachs:{
            attachmentName:'',
            cd:'001-033',
            fileList: [],
            tableDataList:[],
          },
          professorAttachs:{
            attachmentName:'',
            cd:'001-034',
            fileList: [],
            tableDataList:[],
          },
          masterInstructorAttachs:{
            attachmentName:'',
            cd:'001-035',
            fileList: [],
            tableDataList:[],
          },
          doctorInstructorAttachs:{
            attachmentName:'',
            cd:'001-039',
            fileList: [],
            tableDataList:[],
          },
          gcpAttachs:{
            attachmentName:'',
            cd:'001-009',
            fileList: [],
            tableDataList:[],
          },
        },
        autoHeight: {
          height: ''
        },
        departments: [],  //部门数组
        pCodeAndCCode: [],
        activeNames: ['1']
      }
    },

    mounted() {
      this.handlePCodeAndCCode();
      this.handleIdTypeCodes();
    },

    methods: {
      //设置自适应高度
      getHeight() {
        this.autoHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE) + 'px';
      },

      //查询部门id
      getDepartments(){
        let token = cookie.getCookie("token");
        http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', {
          token: token,
          data: {
            pageSize: -1
          }
        }).then(response => {
          this.departments = response.data.data.departments;
          //计算出医院的全id路径
          if (this.form.majorDepartId){
            let departIds = getCascaderFullValue(this.departments,this.form.majorDepartId);
            this.elementDeptId=departIds
          }
        })
      },

      //拿到选择框选择的部门id
      handleDeptChange(value) {
        if(value != null){
          this.$refs.deptCascader.dropDownVisible = false;
          this.elementDeptId = value;
          this.form.majorDepartId = value[value.length -1]
        }
      },

      //拿到省份码表值
      handleCodeChange(value){
        if (value && value.length>0){
          this.$refs.codeCascader.dropDownVisible = false
          this.form.originProvinceCode = value[0]
          this.form.originCityCode = value.length>1?value[1]:'';
        }else {
          this.form.originProvinceCode = '';
          this.form.originCityCode = '';
        }
      },

      //获取籍贯的回显值
      handlePCodeAndCCode() {
        let result = [];
        if (this.form.originCityCode){
          result.push(this.form.originProvinceCode)
          result.push(this.form.originCityCode)
        } else {
          result.push(this.form.originProvinceCode)
        }
        this.pCodeAndCCode = result;
      },

      //获取证件类型回显值
      handleIdTypeCodes(){
        if(this.eimsCodes.length > 0){
          this.eimsCodes.forEach(arr => {
            if(arr.tp=='007'){
              this.array.idTypeCodeArr.push(arr);
            }
          })
        }
      },


      validateFileForm() {
        return true;
      },

      //取消返回成员列表页面
      handleCancelClick() {
        if (this.$route.query.path == '/user/approve') {
          this.$router.push({path:'/user/approve'});
        }else {
          this.$router.push({path:'/user/list'});
        }
      },

      //跳转到下一个页面
      goNextPageClick() {
        let that = this;
        if (!that.validateFileForm()){
          return false;
        }
        let data='/user/info/paper'   //要传的值
        //子路由通过$emit触发父级路由中的方法
        this.$emit('childClick',data)
      },

      //点击查看按钮
      preViewAttachment(item,index,flag){
        //准备需要查看的附件的链接,然后显示或者下载附件
        let fullName=  item.attachmentOriginalName;

        //判断附件类型
        let tableDataList = [];
        let fileList = [];
        if(flag == '001-001'){
          tableDataList = this.fileDialog.practiceQualAttachs.tableDataList;
          fileList = this.fileDialog.practiceQualAttachs.fileList;
        }else if(flag == '001-036'){
          tableDataList = this.fileDialog.medicalLicAttachs.tableDataList;
          fileList = this.fileDialog.medicalLicAttachs.fileList;
        }else if (flag == '001-037') {
          tableDataList = this.fileDialog.juniorProQualAttachs.tableDataList;
          fileList = this.fileDialog.juniorProQualAttachs.fileList;
        }else if (flag == '001-038') {
          tableDataList = this.fileDialog.imdProQualAttachs.tableDataList;
          fileList = this.fileDialog.imdProQualAttachs.fileList;
        }else if (flag == '001-029') {
          tableDataList = this.fileDialog.ascSnrProQualAttachs.tableDataList;
          fileList = this.fileDialog.ascSnrProQualAttachs.fileList;
        }else if (flag == '001-030') {
          tableDataList = this.fileDialog.posSnrProQualAttachs.tableDataList;
          fileList = this.fileDialog.posSnrProQualAttachs.fileList;
        }else if (flag == '001-031') {
          tableDataList = this.fileDialog.teacherQualAttachs.tableDataList;
          fileList = this.fileDialog.teacherQualAttachs.fileList;
        }else if (flag == '001-032') {
          tableDataList = this.fileDialog.lecturerQualAttachs.tableDataList;
          fileList = this.fileDialog.lecturerQualAttachs.fileList;
        }else if (flag == '001-033') {
          tableDataList = this.fileDialog.ascProfessorAttachs.tableDataList;
          fileList = this.fileDialog.ascProfessorAttachs.fileList;
        }else if (flag == '001-034') {
          tableDataList = this.fileDialog.professorAttachs.tableDataList;
          fileList = this.fileDialog.professorAttachs.fileList;
        }else if (flag == '001-035') {
          tableDataList = this.fileDialog.masterInstructorAttachs.tableDataList;
          fileList = this.fileDialog.masterInstructorAttachs.fileList;
        }else if (flag == '001-039') {
          tableDataList = this.fileDialog.doctorInstructorAttachs.tableDataList;
          fileList = this.fileDialog.doctorInstructorAttachs.fileList;
        }else if (flag == '001-009') {
          tableDataList = this.fileDialog.gcpAttachs.tableDataList;
          fileList = this.fileDialog.gcpAttachs.fileList;
        }

        //如果不是图片的格式的附件,则使用上面这种预览方式
        if(!this.attachment.imagesType.includes(fullName.substring(fullName.lastIndexOf(".") + 1))){
          //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
          let file = fileList[index-(tableDataList.length-fileList.length)]
          if (file){
            //附件未上传预览
            this.handleView(file)
          }else{
            //附件已上传的预览
            this.handleView(tableDataList[index])
          }

          //如果是图片则使用这种预览方式
        }else{
          //生成附件的预览链接
          this.generateAttachmentsPath(tableDataList,index)
          if (  this.attachment.attachmentsLink.length !==0 ){
            //el-image组件的预览
            this.$refs.previewImg.showViewer = true;
          }else{
            //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
            this.handleView(fileList[index-(tableDataList.length-fileList.length)])
          }
        }
      },

      //将传来的附件生成附件的链接
      generateAttachmentsPath(attachments,index){
        let attachmentsLink=[]
        //将index这个文件放在第一个,给image组件使用的
        for (let i=index; i<attachments.length;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if (attachment.code !== undefined){
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+attachment.code);
            }
          }
        }
        if ( attachmentsLink.length === 0 ){
          this.attachment.attachmentsLink = []
          return
        }
        for (let i=0; i<index;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if(attachment.code !== undefined) {
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
            }
          }
        }
        this.attachment.attachmentsLink=attachmentsLink
      },

      //准备需要查看的附件的链接,然后显示或者下载附件
      handleView(item){
        if (item.file){
          let fileType= item.file.name.substring(item.file.name.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileFlag.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            elink.download = item.file.name;
          }
          elink.style.display = 'none';
          elink.target='_blank';
          // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
          elink.href = URL.createObjectURL(item.file);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          let fileType= item.attachmentOriginalName.substring(item.attachmentOriginalName.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileFlag.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            http.get(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code,
              { responseType: "blob" }).then(response => {
              if (response){
                let attaFileDownTypeElement = this.fileFlag.attaFileDownType[fileType];
                elink.download = item.attachmentName;
                elink.style.display = 'none';
                elink.target='_blank';
                elink.href = URL.createObjectURL(new Blob([response.data],{type:attaFileDownTypeElement}));
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }).catch(error =>{
              console.log(error)
            })
          }else {
            elink.style.display = 'none';
            elink.target='_blank'
            elink.href = window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code;
            // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        }
      },
    },

    created() {
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
      this.getDepartments();

      //数据回显到页面
      if (this.eimsUserInfoBase && this.eimsUserInfoBase.userId){
        this.form = this.eimsUserInfoBase;
        this.fileDialog.practiceQualAttachs.tableDataList = this.eimsUser.practiceQualAttachs;
        this.fileDialog.medicalLicAttachs.tableDataList = this.eimsUser.medicalLicAttachs;
        this.fileDialog.juniorProQualAttachs.tableDataList = this.eimsUser.juniorProQualAttachs;
        this.fileDialog.imdProQualAttachs.tableDataList = this.eimsUser.imdProQualAttachs;
        this.fileDialog.ascSnrProQualAttachs.tableDataList = this.eimsUser.ascSnrProQualAttachs;
        this.fileDialog.posSnrProQualAttachs.tableDataList = this.eimsUser.posSnrProQualAttachs;
        this.fileDialog.teacherQualAttachs.tableDataList = this.eimsUser.teacherQualAttachs;
        this.fileDialog.lecturerQualAttachs.tableDataList = this.eimsUser.lecturerQualAttachs;
        this.fileDialog.ascProfessorAttachs.tableDataList = this.eimsUser.ascProfessorAttachs;
        this.fileDialog.professorAttachs.tableDataList = this.eimsUser.professorAttachs;
        this.fileDialog.masterInstructorAttachs.tableDataList = this.eimsUser.masterInstructorAttachs;
        this.fileDialog.doctorInstructorAttachs.tableDataList = this.eimsUser.doctorInstructorAttachs;
        this.fileDialog.gcpAttachs.tableDataList = this.eimsUser.gcpAttachs;
      }
      if (this.eimsUser && (this.eimsUser.userId || this.eimsUser.name || this.eimsUser.departmentId)) {
        this.form.userId = this.eimsUser.userId;
        this.form.name = this.eimsUser.name;
        this.form.majorDepartId = this.eimsUser.majorDepartId;
        this.form.practiceQualAttachs = this.eimsUser.practiceQualAttachs;
        this.form.medicalLicAttachs = this.eimsUser.medicalLicAttachs;
        this.form.juniorProQualAttachs = this.eimsUser.juniorProQualAttachs;
        this.form.imdProQualAttachs = this.eimsUser.imdProQualAttachs;
        this.form.ascSnrProQualAttachs = this.eimsUser.ascSnrProQualAttachs;
        this.form.posSnrProQualAttachs = this.eimsUser.posSnrProQualAttachs;
        this.form.teacherQualAttachs = this.eimsUser.teacherQualAttachs;
        this.form.lecturerQualAttachs = this.eimsUser.lecturerQualAttachs;
        this.form.ascProfessorAttachs = this.eimsUser.ascProfessorAttachs;
        this.form.professorAttachs = this.eimsUser.professorAttachs;
        this.form.masterInstructorAttachs = this.eimsUser.masterInstructorAttachs;
        this.form.doctorInstructorAttachs = this.eimsUser.doctorInstructorAttachs;
        this.form.gcpAttachs = this.eimsUser.gcpAttachs;
      }
    },

    destroyed() {
      let that = this;
      let eimsUser = {
        userId: that.form.userId,
        name: that.form.name,
        //这个是为了保存到数据库使用的
        majorDepartId: that.elementDeptId[that.elementDeptId.length - 1] || this.form.majorDepartId ,
        //这个是为了回显组件数据使用的
        elementDeptId: that.elementDeptId,
        practiceQualAttachs: that.form.practiceQualAttachs,
        medicalLicAttachs: that.form.medicalLicAttachs,
        juniorProQualAttachs: that.form.juniorProQualAttachs,
        imdProQualAttachs: that.form.imdProQualAttachs,
        ascSnrProQualAttachs: that.form.ascSnrProQualAttachs,
        posSnrProQualAttachs: that.form.posSnrProQualAttachs,
        teacherQualAttachs: that.form.teacherQualAttachs,
        lecturerQualAttachs: that.form.lecturerQualAttachs,
        ascProfessorAttachs: that.form.ascProfessorAttachs,
        professorAttachs: that.form.professorAttachs,
        masterInstructorAttachs: that.form.masterInstructorAttachs,
        doctorInstructorAttachs: that.form.doctorInstructorAttachs,
        gcpAttachs: that.form.gcpAttachs,
      };
      that.$store.dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": that.form});
      window.removeEventListener('resize', this.getHeight);
    },

    computed: {
      //获取部门名
      deptName: function () {
        let deptName = "";
        if (this.elementDeptId.length == 1){
          deptName = this.departments[0].label
        }
        if (this.elementDeptId.length == 2){
          let list = this.departments[0].children;
          list.forEach((arr,index) => {
            if (arr.value == this.elementDeptId[1]){
              deptName = arr.label;
            }
          })
        }
        if (this.elementDeptId.length == 3){
          let list = this.departments[0].children;
          list.forEach((arr) => {
            if (arr.value == this.elementDeptId[1]){
              let list1 = arr.children;
              list1.forEach((arr1) => {
                if(arr1.value == this.elementDeptId[2]){
                  deptName = arr1.label
                }
              })
            }
          })
        }
        return deptName
      },
      //获取籍贯名
      pCodeAndCName: function () {
        let list = this.codesTree;
        let pCodeAndCName = "";
        list.forEach((arr) => {
          if(arr.value == this.pCodeAndCCode[0]){
            let list1 = arr.children;
            list1.forEach((arr1) => {
              if (arr1.value == this.pCodeAndCCode[1]){
                pCodeAndCName = arr.label + '/' + arr1.label;
              }
            })
          }
        })
        return pCodeAndCName
      },
      ...mapState({
        stateElementDeptId:state => state.elementDeptId,
        eimsUser: state => state.basicInfoModule.eimsUser,
        eimsUserInfoBase: state => state.basicInfoModule.eimsUserInfoBase,
        userUserId: state => state.userModule.userId,
        codesTree: state => state.codeDictModule.codesTree,
        response:state => state.memberAllInfoModule.response,
        eimsCodes : state => state.codeDictModule.eimsCodes,
      })
    }
  }
</script>

<style scoped>
  .info-header{
    padding-bottom: 30px;
    background-color:rgba(93,221,220,0.35);
    border-bottom: 1px solid #EBEEF5;
    width: 100%;
    height: 40px;
    line-height: 40px;
    align-items: center;
    padding-left: 10px;
  }

  /deep/ .cab .is-horizontal{
    display: none;
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
    top: auto !important;
  }

  /deep/ .el-card__body {
    width: 100%;
  }

  .form_span{
    width: 100%;
  }

  /deep/ .el-image__error{
    display: none;
  }

  /deep/ .el-collapse-item__header {
    font-weight: bolder;
    font-size: 15px;
    color: #5ed5d9;
  }

  /deep/ .el-collapse-item__header.focusing:focus:not(:hover),.el-tag {
    color: #5ED5DB;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/BasicViewInfo.vue